import '../../../App.css'
import './end.css'
import Logo from '../../../assets/bg1.png'
import useInView from '../../../utils/useInView';

export default function End() {
    const [titleRef, titleInView] = useInView({ once: false, threshold: 0, rootMargin: '-80px' })

    return (
        <div className="EndMainDiv">
            <div className="imageWrapper">
                <div className="curvedline"></div>
                <img src={Logo} alt="" className="EndImage" loading="lazy" />
            </div>
            <h1 className='Primarysubheading'>
                Ready to Take Control of Your Workflows?
            </h1>
            <p className='HighlightParagraph'>Join thousands who've transformed their money management with our AI-powered platform.</p>
            <div style={{ height: '70px' }}></div>

            <div className='BottomTextAnimation'>
                <div className='endGlow' />
                <div className='endVignette' />
                <h2
                    ref={titleRef}
                    className={`endTitle ${titleInView ? 'endTitle-visible' : ''}`}
                >
                    Jovexa Softlabs
                </h2>
            </div>
        </div>
    )
}
